import React, { useEffect } from "react";
import 'styles/main/Tabs.sass'
import MapTab from 'components/main/MapTab';
import { useDispatch } from 'react-redux';
import InfoTooltip from 'components/controls/InfoTooltip';
import { useTranslation } from 'react-i18next';


import ChartsTab from 'components/main/ChartsTab';


export default function Tabs(props) {
  const {active, setActive} = props
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => { 
    console.log('render Tabs')
  });

  const resetArea = (act) => {
    if (act == "map")
      dispatch({ type: 'SET_GEO_AREA', payload: "full-domain"})
    setActive(act)
  }

  return (
    <div id="tabs">
      <InfoTooltip title={t('tabs.eans.info.title')} body={t('tabs.eans.info.body')} />
      <div class='forecastTitle'>
        <div>ESTIMATED</div>
        <div>ACCURACY NUMBERS</div>
      </div>
      <MapTab active={active} setActive={resetArea} className="tab-map"/>
      <ChartsTab active={active} setActive={resetArea} className="charts-map"/>
    </div>
  )
}